const clpurl = 'https://pragyaa.awsapps.com/connect/contact-trace-records/details/416d05bf-a428-4c90-b813-ddf875093e69?tz=Asia/Kolkata';

export default clpurl;